
export class AgrisLicense {
    agrisLicense: string;
    beforeEncrptPassword: string;
    password: string;
    username: string;
}

